import { Product } from 'teacher-ui-client/utils/products'

export const Precinct = {
  RE_READING: 'reading-eggs-reading',
  RE_SPELLING: 'reading-eggs-spelling',
  RE_STORYLANDS: 'reading-eggs-storylands',
  RE_DRIVING_TESTS: 'reading-eggs-driving-tests',
  REX_READING: 'reading-eggspress-reading',
  REX_SPELLING: 'reading-eggspress-spelling',
  REX_LIBRARY: 'reading-eggspress-library',
  FP_PEAKS: 'fast-phonics-peaks',
  MS_LESSONS: 'mathseeds-lessons',
  MS_MENTAL_MINUTE: 'mathseeds-mental-minute',
  MS_DRIVING_TESTS: 'mathseeds-driving-tests',
  MSP_LESSONS: 'mathseeds-prime-lessons',
  WL_WRITING: 'writing-legends-writing',
  WL_EXCITING_WRITING_IDEAS: 'writing-legends-exciting-writing-ideas',
  WL_LONG_WRITES: 'writing-legends-long-writes',
} as const

export type Precinct = ValuesOf<typeof Precinct>

export function isPrecinct(maybePrecinct: unknown): maybePrecinct is Precinct {
  const valid = Object.values<string>(Precinct)
  return typeof maybePrecinct === 'string' && valid.includes(maybePrecinct)
}

export function isValidPrecinctForProduct(product: Product, precinct: Precinct): boolean {
  switch (product) {
    case Product.RE:
      return (
        [Precinct.RE_READING, Precinct.RE_SPELLING, Precinct.RE_STORYLANDS, Precinct.RE_DRIVING_TESTS] as Precinct[]
      ).includes(precinct)
    case Product.REX:
      return ([Precinct.REX_READING, Precinct.REX_SPELLING] as Precinct[]).includes(precinct)
    case Product.FP:
      return ([Precinct.FP_PEAKS] as Precinct[]).includes(precinct)
    case Product.MS:
      return ([Precinct.MS_LESSONS, Precinct.MS_MENTAL_MINUTE, Precinct.MS_DRIVING_TESTS] as Precinct[]).includes(
        precinct,
      )
    case Product.MSP:
      return ([Precinct.MSP_LESSONS] as Precinct[]).includes(precinct)
    case Product.WL:
      return ([Precinct.WL_WRITING] as Precinct[]).includes(precinct)
    default:
      return false
  }
}

function assertUnreachable(input: unknown): never {
  throw new Error(`Received an unknown product: ${typeof input === 'string' ? input : '(not a string)'}`)
}

export function defaultPrecinctForProduct(product: Product): Precinct {
  switch (product) {
    case Product.FP:
      return Precinct.FP_PEAKS
    case Product.RE:
      return Precinct.RE_READING
    case Product.REX:
      return Precinct.REX_READING
    case Product.MS:
      return Precinct.MS_LESSONS
    case Product.MSP:
      return Precinct.MSP_LESSONS
    case Product.WL:
      return Precinct.WL_WRITING
    default:
      assertUnreachable(product)
  }
}
